module.exports = __webpack_public_path__ + "static/media/stockhausen_philharmonie_1.86787d52.jpg";